import { Component } from '@angular/core';

@Component({
  selector: 'app-modals-header',
  templateUrl: './modals-header.component.html',
  styleUrls: ['./modals-header.component.css'],
})
export class ModalsHeaderComponent { }
